// 相場を調べる補助リンク。
// 7/15定例の決定: 相場は「営業が自分でGoogle等で同等品を検索して価格を拾い、手入力する」運用。
// このコンポーネントは "調べ方" をツール内に固定化した検索ショートカット（自動取得はしない）。
// アイテム名（＋市場名）で 各サイトの検索を新タブで開くだけ。入力は引き続き人がやる。

type Props = {
  itemName?: string | null; // 例: アクリルキーホルダー
  marketName?: string | null; // 例: スポーツ・イベント（任意・検索語に足す）
  className?: string;
};

type LinkDef = {
  label: string;
  build: (q: string) => string;
};

// 検索先。goods相場を拾う実用的な導線に絞る。
const TARGETS: LinkDef[] = [
  { label: "Google", build: (q) => `https://www.google.com/search?q=${q}` },
  { label: "Google画像", build: (q) => `https://www.google.com/search?tbm=isch&q=${q}` },
  { label: "楽天", build: (q) => `https://search.rakuten.co.jp/search/mall/${q}/` },
  { label: "Amazon", build: (q) => `https://www.amazon.co.jp/s?k=${q}` },
];

export function MarketPriceLinks({ itemName, marketName, className = "" }: Props) {
  const item = (itemName ?? "").trim();
  if (!item) return null;

  // 「アイテム名 市場名 価格 相場」で同等品の価格帯を拾いやすくする。
  // 市場名は () や ・ を含むことがあるので検索語としてはアイテム名を主にする。
  const words = [item, (marketName ?? "").trim(), "価格", "相場"].filter(Boolean);
  const q = encodeURIComponent(words.join(" "));

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-xs text-ink-muted">相場を調べる:</span>
      {TARGETS.map((t) => (
        <a
          key={t.label}
          href={t.build(t.label === "楽天" ? encodeURIComponent(words.join(" ")) : q)}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full ring-1 ring-ink/15 bg-white text-ink hover:ring-ink/40 transition"
        >
          {t.label}
          <span className="text-[10px] text-ink-muted">↗</span>
        </a>
      ))}
      <span className="text-[11px] text-ink-muted">
        同等品を検索して価格帯（安値〜高値）を拾い、下の欄に手入力してください
      </span>
    </div>
  );
}
